import {store} from '../../store/store';
import timeReportReducer, {setData} from './slice';
import { TimeReportItem } from './types';

export const setTimeReportData = (data: Array<TimeReportItem>) => {
    store.dispatch(setData(data))
}

export { timeReportReducer };
